export const TipoAditivoIds = Object.freeze({
    AcrescimoSupressao:              1,
    Prazo:                           2,
    Reajuste:                        3,
    RenovacaoPrazoEValor:            4,
    ReajusteFinanceiroPrazoObsoleto: 5,
    Outro:                           6,
    Repactuacao:                     7,
    Revisao:                         8,
    // 9 = TAC — reservado para release posterior
    TermoDeQuitacao:                 10
})

export const ALTERA_VALOR = Object.freeze([
    TipoAditivoIds.AcrescimoSupressao,
    TipoAditivoIds.Reajuste,
    TipoAditivoIds.RenovacaoPrazoEValor,
    TipoAditivoIds.Outro,
    TipoAditivoIds.Repactuacao,
    TipoAditivoIds.Revisao,
    TipoAditivoIds.TermoDeQuitacao
])

export const ALTERA_PRAZO = Object.freeze([
    TipoAditivoIds.Prazo,
    TipoAditivoIds.Reajuste,
    TipoAditivoIds.RenovacaoPrazoEValor,
    TipoAditivoIds.TermoDeQuitacao
])

export function alteraValor(ids) {
    return Array.isArray(ids) && ids.some(id => ALTERA_VALOR.includes(id))
}

export function alteraPrazo(ids) {
    return Array.isArray(ids) && ids.some(id => ALTERA_PRAZO.includes(id))
}
